/// <reference path="../types/index.d.ts" />

import '../client_forms/tcagbevent/style.css';
import FormStructure from './tcagbevent/form_structure';

export default FormStructure;